import { useEffect, useMemo, useState } from "react";
import { FileDown } from "lucide-react";
import { toast } from "sonner";
import { api, exportFile } from "../lib/api";
import { Empty, Loading, Panel } from "./common";
import { ShiftGrid } from "./ShiftGrid";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const key = (a, m) => `${a}-${String(m).padStart(2, "0")}`;
const label = (k) => { const [a, m] = k.split("-"); return `${MESI[Number(m) - 1]} ${a}`; };

export function MyShiftsTable({ shifts, admin = false }) {
  const now = new Date();
  const cur = key(now.getFullYear(), now.getMonth() + 1);
  const months = useMemo(() => [...new Set([...shifts.map((s) => key(s.anno, s.mese)), cur])].sort(), [shifts, cur]);
  const [month, setMonth] = useState(months.includes(cur) ? cur : months[months.length - 1]);
  const [rep, setRep] = useState("Mare");
  const [d, setD] = useState(null);
  const [anno, mese] = month.split("-").map(Number);
  const q = `mese=${mese}&anno=${anno}${admin ? `&reparto=${rep}` : ""}`;
  useEffect(() => {
    let live = true;
    setD(null);
    const p = admin ? api(`/admin/shifts?${q}`).then((r) => ({ ...r, reparto: rep })) : api(`/shifts/table?${q}`);
    p.then((r) => { if (live) setD(r); }).catch(() => { if (live) setD({ shifts: [] }); });
    return () => { live = false; };
  }, [q, admin, rep]);
  const doPdf = async () => { try { await exportFile(admin ? `/admin/shifts/export/pdf?${q}` : `/shifts/table/export/pdf?${q}`); toast.success("PDF dei turni scaricato"); } catch { toast.error("Errore durante l'export PDF"); } };
  return (
    <div>
    {admin && (
      <div className="flex gap-2 mb-3" role="tablist">{["Mare", "Uffici"].map((r) => (
        <button key={r} role="tab" aria-selected={rep === r} onClick={() => setRep(r)} data-testid={`shifts-sheet-${r.toLowerCase()}`}
          className={`rounded-t-xl px-6 py-2.5 text-sm font-semibold transition-colors ${rep === r ? "bg-[var(--navy)] text-white" : "bg-white border border-slate-200 text-[var(--navy)] hover:bg-slate-50"}`}>Reparto {r}</button>))}
      </div>)}
    <Panel className="!p-0 overflow-hidden" data-testid="my-shifts-table">
      <div className="flex flex-wrap items-center justify-between gap-3 p-4 border-b">
        <Select value={month} onValueChange={setMonth}>
          <SelectTrigger className="w-48 bg-white" data-testid="my-shifts-month"><SelectValue /></SelectTrigger>
          <SelectContent>{months.map((m) => <SelectItem key={m} value={m} data-testid={`my-shifts-month-${m}`}>{label(m)}</SelectItem>)}</SelectContent>
        </Select>
        {d?.reparto && <span className="tag tag-teal" data-testid="my-shifts-reparto">Reparto {d.reparto}</span>}
        <Button variant="outline" className="rounded-full" onClick={doPdf} disabled={!d?.shifts?.length} data-testid="my-shifts-export-pdf"><FileDown className="w-4 h-4 mr-1" />Esporta PDF</Button>
      </div>
      {!d ? <Loading /> : !d.shifts?.length ? <Empty title="Nessun turno" text="Turni non ancora pubblicati per questo mese." /> : <ShiftGrid d={d} mese={mese} anno={anno} testid="my-shifts-grid" />}
    </Panel>
    </div>
  );
}
